import { createFileRoute } from '@tanstack/react-router';

import { ProductsCatalogPage } from '../../pages/catalog/products/ProductsCatalogPage';

export const Route = createFileRoute('/_auth/catalog/processes/$processId/categories/$categoryId/products/$')({
  component: ProductsCatalogPage,
});
